// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'normalize.css/normalize.css'
import './styles/base.css'
import router from './router'
import Meta from 'vue-meta'
import 'babel-polyfill'
import 'input-placeholder-polyfill'
import user from "@/api/user";

Vue.use(Meta)
    // import ElementUI from 'element-ui';
import { Form, FormItem, Input, Button, Message, MessageBox, Upload } from 'element-ui';
Vue.use(FormItem);
Vue.use(Form);
Vue.use(Input);
Vue.use(Upload);
Vue.use(Button);
Message.install = function(Vue, options) {
    Vue.prototype.$Message = Message
}
MessageBox.install = function(Vue, options) {
    Vue.prototype.$MessageBox = MessageBox
}
Vue.use(Message);

Vue.use(MessageBox);

Vue.filter('hiddenPhoneNum', function(value) {
    if (!value) return '暂 无'
    var reg = /^(\d{3})\d{4}(\d{4})$/;
    value = value.toString();
    value = value.replace(reg, "$1****$2");
    return value;
})
Vue.config.productionTip = false
if (process.env.NODE_ENV === "development") {
    Vue.prototype.varHost = "https://i.betaenv.com/"
} else if (process.env.NODE_ENV === "production") {
    Vue.prototype.varHost = "/"
} else {
    Vue.prototype.varHost = "/"
}

if(window.location.host === 'i.huanqiu.com'){
    Vue.prototype.varUCHost = "https://vip.i.huanqiu.com/"
}else {
    Vue.prototype.varUCHost = "https://vip-i.betaenv.com/"
}

let browser = {
    versions: function() {
        var u = navigator.userAgent,
            app = navigator.appVersion;
        return { //移动终端浏览器版本信息
            trident: u.indexOf('Trident') > -1, //IE内核
            presto: u.indexOf('Presto') > -1, //opera内核
            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
            iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
            webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
        };
    }(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
}

Vue.prototype.isMobile = browser.versions.mobile
router.beforeEach((to, from, next) => {
        // console.log(to.path, from.path)
        if (browser.versions.mobile) {
            if (to.path === '/login') {
                next({ path: '/mlogin' })
            } else if (browser.versions.mobile && to.path === '/resetPassword') {
                next({ path: '/mresetPassword' })
            } else if (browser.versions.mobile && to.path === '/register') {
                next({ path: '/mregister' })
            } else {
                if(to.path !== '/mlogin'&&to.path !== '/mresetPassword'&& to.path !== '/mregister' && to.path !== '/agreement'){
                    user
                        .getUserInfo()
                        .then(result => {
                            next();
                            if(result.status === 200){
                                location.href = "https://m.huanqiu.com";
                            }
                        })
                        .catch(err => {
                            console.log(err);
                            next();
                        });
                }else{
                    next();
                }
            }
        } else {
            if (to.path === '/mlogin') {
                next({ path: '/login' })
            } else if (to.path === '/mresetPassword') {
                next({ path: '/resetPassword' })
            } else if (to.path === '/mregister') {
                next({ path: '/register' })
            } else {
                next();
            }
        }
    })
    //Ie8到11打不开页面，在html中增加console的polyfill，暂用空函数来保证不会报错:
if (!window.console) {
    window.console = {
        log: function(msg) {},
        err: function(msg) {},
        warn: function(msg) {},
    }
}


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js